import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0865bd90"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "top"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top-title"
}, [/*#__PURE__*/_createTextVNode("Inventory / "), /*#__PURE__*/_createElementVNode("span", null, " Demand forecasting")], -1));
const _hoisted_3 = {
  class: "top-right"
};
const _hoisted_4 = {
  class: "sub_category_title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_seller_filter = _resolveComponent("seller-filter");
  const _component_empty_segments = _resolveComponent("empty-segments");
  const _component_segment_filter = _resolveComponent("segment-filter");
  const _component_product_filter = _resolveComponent("product-filter");
  const _component_app_dropdown = _resolveComponent("app-dropdown");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
  const _component_app_dropdown_item = _resolveComponent("app-dropdown-item");
  const _component_app_button = _resolveComponent("app-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_seller_filter, {
    sellers: _ctx.sellers_filter,
    onlyMode: true,
    onApply: $options.applySellers,
    onCleared: $options.clearSellers
  }, null, 8, ["sellers", "onApply", "onCleared"]), _createVNode(_component_segment_filter, {
    segments: _ctx.segments_filter,
    sellers: _ctx.sellers_filter,
    onApply: $options.applySegments,
    onCleared: $options.clearSegments
  }, {
    empty: _withCtx(() => [_createVNode(_component_empty_segments)]),
    _: 1
  }, 8, ["segments", "sellers", "onApply", "onCleared"]), _createVNode(_component_product_filter, {
    products: _ctx.products_filter,
    sellers: _ctx.sellers_filter,
    onApply: $options.applyProducts,
    onCleared: $options.clearProducts
  }, null, 8, ["products", "sellers", "onApply", "onCleared"]), _createVNode(_component_app_dropdown, {
    modelValue: _ctx.itemScaleType,
    "onUpdate:modelValue": [_cache[0] || (_cache[0] = $event => _ctx.itemScaleType = $event), $options.handleScaleTypeChange],
    options: $data.options,
    icon: "unit-scale"
  }, null, 8, ["modelValue", "options", "onUpdate:modelValue"]), _createVNode(_component_app_dropdown, {
    arrow_icon_color: "#fff",
    class: "export-dropdown"
  }, {
    "button-content": _withCtx(() => [_createVNode(_component_app_icon, {
      icon: "rocket",
      size: 13,
      color: "#FFF"
    }), _createTextVNode(" Order " + _toDisplayString($props.selected.length ? "selected items" : "all"), 1)]),
    body: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.order_options_categories, category => {
      return _openBlock(), _createBlock(_component_app_dropdown_item, null, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_4, _toDisplayString(category.toUpperCase()), 1)]),
        body: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.order_options.filter(item => item.sub_category == category), item => {
          return _openBlock(), _createBlock(_component_b_dropdown_item, {
            onClick: $event => $options.handleOrder(item)
          }, {
            default: _withCtx(() => [_createVNode(_component_flex_row, {
              styles: {
                justifyContent: 'space-between'
              },
              gap: 4
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item?.text) + " ", 1), (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                key: `order-option-${item.text}`
              }))]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1032, ["onClick"]);
        }), 256))]),
        _: 2
      }, 1024);
    }), 256))]),
    _: 1
  }), _createVNode(_component_app_button, {
    variant: "text",
    version: "small",
    v2: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_app_icon, {
      icon: "info-circle"
    })]),
    _: 1
  })])]);
}